import { DashboardRoute } from "@/routes/dashboard";
// import { DashboardRemindersRoute } from "@/routes/reminder";
import { baseRoute as changeServiceRoute } from "@/routes/changeservice";
import { baseRoute as topDealsRoute } from "@/routes/topdeals";
import { ContactRoute } from "@/routes/content";
import { FaqBaseRoute } from "@/routes/faq";
import { SecondLandingPageRoute } from "@/routes/dynamicLandingpages";
import { MyProfileRoute } from "@/routes/myProfile";
import { MyShortOffersBaseRoute } from "@/routes/offer";
import { AdvisorRoute } from "@/routes/advisor";
import { BonusRoute } from "@/routes/bonus";
import { PhotovoltaicRoute } from "@/routes/photovoltaic";
import { B2bRoute } from "@/routes/b2b";

export type menuItemI = {
  label: string;
  url?: string;
  hide?: string[];
  children?: menuItemI[];
};

const WLs = ["medion", "focus", "schnaeppchenfuchs"];
const hostname = window.location.hostname;
const dashboardLabel = WLs.some((wl) => hostname.includes(wl)) ? "Meine Services" : "Mein remind.me";

export const leftNavigationItems: menuItemI[] = [
  {
    label: dashboardLabel,
    url: DashboardRoute,
    hide: ["anon"],
  },
  {
    label: "Strom",
    url: `${SecondLandingPageRoute}?categoryType=ELECTRICITY`,
    hide: ["auth"],
  },
  {
    label: "Gas",
    url: `${SecondLandingPageRoute}?categoryType=GAS`,
    hide: ["auth"],
  },
  {
    label: "Wärmepumpe",
    url: "#",
    hide: ["auth", "anon"],
  },
  {
    label: "Angebote",
    url: MyShortOffersBaseRoute,
    hide: ["anon"],
  },
  {
    label: "Wechselservice",
    url: changeServiceRoute,
    hide: ["anon"],
  },
  {
    label: "Solar",
    url: PhotovoltaicRoute,
  },
  {
    label: "Gewerbekunden",
    url: B2bRoute,
  },
  {
    label: "Ratgeber",
    url: AdvisorRoute,
    hide: ["auth", "ratgeber"],
  },
  {
    label: "Top-Deals",
    url: topDealsRoute,
    hide: ["auth", "topDeals"],
  },
];

export const getRightNavigationItems = (showReferral: boolean, userEmail?: string): menuItemI[] => {
  return [
    ...(showReferral
      ? [
          {
            label: "Freunde werben",
            url: `/mein-remindme/freunde-werben-freunde?email=${userEmail}&autoDetect=1`,
            hide: ["freunde-werben-freunde"],
          },
        ]
      : []),
    {
      label: "Hilfe & Kontakt",
      children: [
        {
          label: "Fragen & Antworten",
          url: FaqBaseRoute,
        },
        {
          label: "Kontakt",
          url: ContactRoute,
        },
      ],
    },

    {
      label: "profile",
      hide: ["anon"],
      children: [
        {
          label: "Profil",
          url: MyProfileRoute,
        },
        // {
        //   label: "Erinnerungen",
        //   url: DashboardRemindersRoute,
        //   hide: ["reminders"],
        // },
        {
          label: "Meine Prämien",
          url: BonusRoute,
        },
        {
          label: "logout",
        },
      ],
    },
  ];
};

export const hideNavigationRoutes = [
  "abschlie%C3%9Fen/",
  "wechselservice-sieger-fuer-strom-und-gas",
  "wechselservice-sieger-fuer-heizstrom",
];
